import { useEffect, useState } from "react";
import { getAccountTaxesAsync } from "../../../../../services/taxService";
import { getCurrencyAmount } from "./../../../../../utils/stringUtils";
import Table from "./../../../../../components/common/Table";
import Pagination from "./../../../../../components/common/Pagination";
import moment from "moment";

const TaxesTable = ({ id, columns, data, setData, tableOptions, onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchTaxes = async () => {
      setIsLoading(true);

      const response = await getAccountTaxesAsync(id, tableOptions);
      const { result, page, total_count } = response;

      const taxes = result.map((item) => {
        const amount = getCurrencyAmount(item.amount);
        const year_quarter = (
          <p className="text-sm text-gray-400">
            {item.year} — {item.return_period_name}
          </p>
        );

        const tax_type = (
          <>
            <p className="text-gray-500 text-sm">{item.tax_type_name}</p>
            {item.ocn && (
              <span className="text-gray-400 text-xs">{item.ocn}</span>
            )}
          </>
        );

        item["tax_type_label"] = item.tax_type_name;
        item["tax_type_name"] = tax_type;

        item["amount_value"] = item.amount;
        item["amount"] = <span>&#8369; {amount}</span>;

        item["return_period_value"] = item.return_period;
        item["return_period"] = year_quarter;
        item["filing_date_value"] = item.filing_date;
        item["filing_date"] = moment(item.filing_date).format("LL");
        item["payment_date_value"] = item.payment_date;
        item["payment_date"] = moment(item.payment_date).format("LL");

        return item;
      });

      if (mounted) {
        setData(taxes);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchTaxes();

    return () => {
      mounted = false;
    };
  }, [id, tableOptions, setData]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default TaxesTable;
